<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <div
      v-if="showSuccessPopup"
      class="rfp-rr-write-review-success-235-or review-popup full-review-active selectPage-in-drop-down"
      data-popup="review-popup"
      style="display: block"
    >
      <div class="rfp-rr-write-review-success-236-or review-popup-close" @click="closePopup">
        {{ popupClose }}
      </div>
      <div id="success-message" class="rfp-rr-write-review-success-237-or popup-inner">
        <div
          class="rfp-rr-write-review-success-238-or message-icon success"
          :class="{ 'image--display': successIcon === '' }"
        >
          <img :src="successIcon" :style="{ width: '100%' }" :alt="successIconAltText" />
        </div>
        <div class="rfp-rr-write-review-success-239-or message" v-html="successText"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-ratings-write-review-success',
  props: {
    successIcon: {
      type: String,
      required: true,
    },
    successText: {
      type: String,
      required: true,
    },
    successIconAltText: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showSuccessPopup: false,
      activeSlider: false,
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('showSuccessReview', () => {
      eventBus.emit('ScrollFalse');
      document.body.classList.add('rare-custom-body-class');
      this.activeSlider = true;
      this.showSuccessPopup = true;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.toggle('popup_scroll');
    });
  },
  methods: {
    closePopup() {
      this.showSuccessPopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.remove('popup_scroll');
      document.body.classList.remove('rare-custom-body-class');
      this.activeSlider = false;
      eventBus.emit('ScrollTrue');
    },
  },
};
</script>
